import { EventDTO } from "../dtos/guest";
import coverImage from './../../assets/images/event-placeholder-img.jpg';

const host: EventDTO['moment']['host'] = {
    id: 'fake-host',
    name: 'Sam Carter',
    username: 'samcarter',
    first_name: 'Sam',
    last_name: 'Carter',
};

const access: EventDTO['access'] = {
    is_invited: false,
    invite_status: null,
    has_pending_request: false,
    request_supported: false,
    can_rsvp: false,
};

function fakeEvent(id: string, title: string, thumbnail_url: string | null): EventDTO {
    return {
        moment: {
            id,
            title,
            start_date: '2026-10-10T18:00:00Z',
            end_date: '2026-10-10T23:00:00Z',
            thumbnail_url,
            host,
        },
        access,
    };
}

/** Open `/guest-event?event=<key>`; any other key shows "Event does not exist". */
export const FAKE_EVENTS: Record<string, EventDTO> = {
    cover: fakeEvent('cover', 'Water balloon fight', coverImage),
    nocover: fakeEvent('nocover', 'Game night', null),
    'long-title': fakeEvent(
        'long-title',
        "Sam's 30th birthday picnic at Hyde Park with everyone from the old office and their families",
        coverImage,
    ),
};
